<template>
  <div class="w-100">
    <v-container>
      <v-row>
        <v-col cols="12" class="text-center">
          <div class="text-h4 my-10 mb-12">
            Den här sidan finns tyvärr inte.
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import Setup from '@/mixins/Setup.js'

export default {
  mixins: [Setup]
}
</script>
